export const VIDEO_PROPS = {
  src: 'https://www.youtube.com/embed/w5d-bgXwFmA',
  allow:
    'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
  allowFullScreen: true,
  className: 'w-full aspect-video border border-purple-200 rounded-lg',
};
